import storage from 'redux-persist/lib/storage';

export const SET_GLOBALS = 'SET_GLOBALS';

export const persistUserConfig = {
    key: 'globals',
    storage
};

export interface GlobalsState {
    vat: number | null;
}

type GlobalsAction = {
    type: typeof SET_GLOBALS;
    payload: {
        vat: number;
    };
};


const initialState: GlobalsState = {
    vat: null
};

function GlobalsReducer(state = initialState, action: GlobalsAction) {
    switch (action.type) {
    case SET_GLOBALS: {
        return Object.assign({}, state, {
            vat: action.payload.vat
        });
    }
    default:
        break;
    }

    return state;
}

export default GlobalsReducer;
